import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { Dispatch, SetStateAction, MouseEvent, useState, useEffect } from 'react'
import { OVsByFilters } from 'services/manage_ov/interface'
import { useSelector } from 'store/store'
import * as S from './styles'

import { getOvStatusOptionsToSap, OvDataToSap } from 'container/ManageOVDetails/utils'
import { SapOptionsToOvStatus } from 'store/OVContext/ovContextTypes'
import { SapModalTypes } from 'container/ManageOVDetails/components/SapModal'
import { Icon } from 'components'
import { theme } from 'styles/theme/hav-theme'

type ContextMenuProps = {
  setCurrentModal: Dispatch<SetStateAction<SapModalTypes | undefined>>
  setOvsSapData: Dispatch<SetStateAction<SapOptionsToOvStatus>>
  ovData: OVsByFilters
}

const OvMenu = ({ setCurrentModal, ovData, setOvsSapData }: ContextMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const { checkedOvs } = useSelector((state) => state.salesOrder)
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const [isMenuDisabled, setIsMenuDisabled] = useState(true)
  const [menuOptions, setMenuOptions] = useState<SapOptionsToOvStatus>(
    {} as SapOptionsToOvStatus
  )

  const ovDataToSap: OvDataToSap[] = [
    {
      number: ovData.NumeroOrdemVenda,
      changeDate: ovData.DataAlteracao,
      statusKey: ovData.StatusOrdemVenda
    }
  ]

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleSapModal = (
    ovOptions: SapOptionsToOvStatus,
    modal: SapModalTypes
  ): void => {
    setOvsSapData(ovOptions)
    setCurrentModal(modal)
    handleClose()
  }

  useEffect(() => {
    setMenuOptions(getOvStatusOptionsToSap(ovDataToSap))
  }, [ovData])

  useEffect(() => {
    const noActionAllowed =
      !menuOptions.isValidToReturnFromSap &&
      !menuOptions.isValidToSendToSap &&
      !menuOptions.isValidToReturnToSalesArea
    if (checkedOvs.length > 1 || noActionAllowed) {
      setIsMenuDisabled(true)
    } else {
      setIsMenuDisabled(false)
    }
  }, [checkedOvs, menuOptions])

  return (
    <>
      <S.ButtonStyled
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        disabled={isMenuDisabled}
      >
        <Icon
          icon="ellipsis"
          color={
            isMenuDisabled ? theme.colors.neutral.lighthover : theme.colors.primary.main
          }
          size="15"
        />
      </S.ButtonStyled>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        {menuOptions.isValidToSendToSap && (
          <MenuItem onClick={() => handleSapModal(menuOptions, 'sendModal')}>
            Enviar ao SAP
          </MenuItem>
        )}

        {menuOptions.isValidToReturnFromSap && (
          <MenuItem onClick={() => handleSapModal(menuOptions, 'returnModal')}>
            Retornar do SAP
          </MenuItem>
        )}

        {menuOptions.isValidToReturnToSalesArea && (
          <MenuItem onClick={() => handleSapModal(menuOptions, 'salesAreaModal')}>
            Devolver
          </MenuItem>
        )}
      </Menu>
    </>
  )
}

export default OvMenu
